// user-client/src/protocol/events.js
// 서버/클라 공용 이벤트 이름 상수 집합
// FE/BE가 동일한 문자열을 사용하도록 단일 소스 유지

export const EVENTS = Object.freeze({


  /*기본 브로드캐스트용*/
  SYNC_STATE: 'sync_state',

  // [ADD][ANCHOR:EVENTS:RECOVERY_RECONNECT_PROBE]
  /* 연결/복구(로비/테이블 공통) */
  RECOVERY_TABLES:   'recoveryTables',     // rootSocket → client: 복구 테이블 목록
  IDENTIFY:          'identify',           // client → server: 식별(root/game 공통)
  IDENTIFY_OK:       'identify_ok',        // server → client: 식별 완료
  PLAYER_CONN_STATE: 'player_conn_state',  // server → client: 좌석 연결상태 브로드캐스트
  CONNECTION_PROBE:  'CONNECTION_PROBE',   // server → client: 재접속 ack probe
  CLIENT_RECONNECT:  'client_reconnect',   // client → server: 재연결 명시 요청

  /* 로비/공통 */
  INITIAL_ACTIVE_USERS: 'initialActiveUsers',
  USER_JOINED:          'userJoined',
  USER_LEFT:            'userLeft',


  /* cashier / payment */
  CASHIER_DEPOSIT_REQUEST:  'cashier:deposit:request',
  CASHIER_WITHDRAW_REQUEST: 'cashier:withdraw:request',
  CASHIER_HISTORY_REQUEST:  'cashier:history:request',
  CASHIER_HISTORY_DELETE_REQUEST: 'cashier:history:delete',
  CASHIER_CANCEL_REQUEST:   'cashier:request:cancel',
  CASHIER_RECHECK_REQUEST:  'cashier:request:recheck',
  CASHIER_DEPOSIT_SESSION_EXTEND:   'cashier:deposit:session:extend',
  CASHIER_DEPOSIT_FINALIZE_PARTIAL: 'cashier:deposit:finalize-partial',
  CASHIER_DEPOSIT_REFUND_REQUEST:   'cashier:deposit:refund-request',
  CASHIER_REQUEST_QUEUED:   'cashier:request:queued',
  CASHIER_REQUEST_REJECTED: 'cashier:request:rejected',
  CASHIER_STATUS_UPDATE:    'cashier:status:update',
  CASHIER_RESULT_UPDATE:    'cashier:result:update',
  CASHIER_BRIDGE_REGISTER:  'cashier:bridge:register',
  CASHIER_BRIDGE_DISPATCH:  'cashier:bridge:dispatch',

  /* 테이블/좌석 */
  REQUEST_SEAT_CONFIRMATION: 'requestSeatConfirmation',
  SEAT_CONFIRMED:            'seatConfirmed',
  SEAT_TIMEOUT:              'seatTimeout',
  TABLE_UPDATE:              'tableUpdate',

  // [ADD][ANCHOR:EVENTS:SEAT_LEFT]
  // ✅ 좌석 비움/퇴장/퇴출 브로드캐스트(standUp/leaveTable/kick 공용)
  SEAT_LEFT:                 'seatLeft',

  /* 로그 브로드캐스트 */
  DEBUG_LOG: 'debugLog',
  INFO_LOG:  'infoLog',
  WARN_LOG:  'warnLog',
  ERROR_LOG: 'errorLog',


  /* === NLH 진행 === */
  // 오프닝
  GAME_OPENING:        'Game_opening',

  // 포지션/블라인드
  SET_BLIND_INFO_RESULT: 'set_a_blind_info_result',

  // 블라인드 포스트
  POST_SMALL_BLIND_BET_REQUEST:  'post_small_blind_bet_request',
  POST_SMALL_BLIND_BET_FINISH:   'post_small_blind_bet_finish',
  POST_BIG_BLIND_BET_REQUEST:  'post_big_blind_bet_request',
  POST_BIG_BLIND_BET_FINISH:   'post_big_blind_bet_finish',

  // 홀카드
  DRAW_HOLE_REQUEST: 'Drawholdcardrequest',

  // 액션 턴
  YOUR_TURN_UI_REQUEST: 'Yourturn ui request',
  YOUR_TURN_UI_RESULT:  'Yourturn ui result',
  YOUR_TURN_UI_RESULT_ERROR: 'Yourturn ui result error',
  YOURTURN_RESULT:      'yourturn_result',

  // 팟 요약/표시
  DISPLAY_POT:        'display_pot',
  FINISH_DISPLAY_POT: 'finish_display_pot',
  // 경량 팟 업데이트(숫자만 빠르게 동기화)
  POT_UPDATE:         'pot_update',

  // 커뮤니티 카드 공개
  OPEN_FLOP_REQUEST:  'Open Flop request',
  OPEN_FLOP_RESULT:   'Open Flop result',
  OPEN_TURN_REQUEST:  'Open Turn request',
  OPEN_TURN_RESULT:   'Open Turn result',
  OPEN_RIVER_REQUEST: 'Open River request',
  OPEN_RIVER_RESULT:  'Open River result',

  // 쇼다운/결과
  GAME_RESULT_UI_REQUEST: 'GameResultUIrequest',
  GAME_RESULT_UI_RESULT: 'GameResultUIresult',
    // 스트리트/핸드 종료(브로드캐스트)
  FINISH_STREET: 'finish_street',
  FINISH_HAND:   'finish_hand',
  RESET_UI: 'reset_ui',

  /* === SIDE GAME (사이드게임 신청/투표) === */
  // ⭐ 프론트 → 백엔드: 사이드게임 신청 이벤트
  SIDEGAME_REQUEST:     'SIDEGAME:REQUEST',

  // ⭐ 백엔드 → 프론트: 투표 시작 브로드캐스트 (10초 카운트다운 표시)
  SIDEGAME_VOTE_START:  'SIDEGAME:VOTE_START',

  // ⭐ 프론트 → 백엔드: 유저가 투표 ACK(찬성/반대 or 도네이션 금액 포함) 보낼 때
  SIDEGAME_VOTE_ACK:    'SIDEGAME:VOTE_ACK',

  // ⭐ 백엔드 → 프론트: 투표 결과 브로드캐스트 (성공/실패, 도네이션 데이터 포함 가능)
  SIDEGAME_VOTE_RESULT: 'SIDEGAME:VOTE_RESULT',

  // ⭐ 현상금 이벤트
  BOUNTY_CREATE: 'BOUNTY:CREATE',
  BOUNTY_UPDATE: 'BOUNTY:UPDATE',   // 서버 → 프론트: 현상금 생성/금액 변경/상태 변경 브로드캐스트
  BOUNTY_REMOVE: 'BOUNTY:REMOVE',   // 서버 → 프론트: 현상금 제거 브로드캐스트
   // [ADD][ANCHOR:EVENTS:BOUNTY_CANCEL_REQUEST]
  // ✅ 프론트 → 백엔드: 오너가 취소(환불) 요청을 보낼 때
  BOUNTY_CANCEL_REQUEST: 'BOUNTY:CANCEL:REQUEST',

  // ⭐ 쇼다운쪽 카드 공개 
   REVEAL_HOLE_CARDS: 'REVEAL_HOLE_CARDS', //서버 → 프론트: 사이드게임 원타임,올인25 에서 쇼다운때받는 홀카드의 경우 리스너 담당
  REVEAL_SHOWDOWN_HOLES: 'REVEAL_SHOWDOWN_HOLES', // 서버 → 프론트: 쇼다운 승부에서 카드 공개 애니메이션 용 리스너 담당


  // ⭐ 미션 이벤트
  MISSION_SNAPSHOT: 'MISSION_SNAPSHOT',
  TABLE_MISSION_REWARD: 'TABLE_MISSION_REWARD',
  TABLE_MISSION_REWARD_QUEUED: 'TABLE_MISSION_REWARD_QUEUED',

  // 테이블 유저별 플레이 설정
  TABLE_USER_SETTINGS_UPDATE: 'TABLE_USER_SETTINGS_UPDATE',
  TABLE_USER_SETTINGS_UPDATED: 'TABLE_USER_SETTINGS_UPDATED',

  // 아바타 테이블 표현(임시 5초 연출)
  AVATAR_EXPRESSION_USE: 'AVATAR:EXPRESSION:USE',
  AVATAR_EXPRESSION: 'AVATAR:EXPRESSION',

 // [ADD][ANCHOR:EVENTS:CHAT_SERVER_EVENTS]
  /* chat-server (backend-chat) */
  CHAT_JOIN:   'chat:join',
  CHAT_LEAVE:  'chat:leave',
  CHAT_SEND:   'chat:send',
  CHAT_RECENT: 'chat:recent',

  CHAT_MESSAGE: 'chat:message',
  CHAT_WARN:    'chat:warn',
  CHAT_LOCKED:  'chat:locked',
  CHAT_ERROR:   'chat:error',
  CHAT_SYSTEM:  'chat:system',
  CHAT_PRESENCE:'chat:presence',



});

export default EVENTS;
